import { FileLinkField } from 'admin/fields/FileLinkField';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import {
  BooleanField,
  DateField,
  Labeled,
  ReferenceField,
  SelectField,
  Show,
  SimpleShowLayout,
  TextField,
} from 'react-admin';

import { REPORT_TYPE_CHOICES } from './reportUtils';

export const ReportShow: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  const showDownloadLink = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);

  return (
    <Show>
      <SimpleShowLayout>
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <SelectField choices={REPORT_TYPE_CHOICES} label="Typ" source="type" />
        {showDownloadLink && (
          <Labeled>
            <FileLinkField label="Výstup" source="file.id" />
          </Labeled>
        )}
        <BooleanField label="Publikované" source="published" />
        <DateField label="Dátum vytvorenia" locales="sk" showTime={true} source="creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" showTime={true} source="updateTimestamp" />
      </SimpleShowLayout>
    </Show>
  );
};
